import { Component, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { debounceTime, Subject, takeUntil } from 'rxjs';

import { ErrorComponent } from "../error/error.component";
import {environment} from "../../environments/environment";
import { DynaDimmerStateService } from "../core-module/services/state/dyna-dimmer-state.service";
import { MultiOneHttpClient } from "../core-module/services/state/multi-one-http-client.service";
@Component({
  standalone: false,
  selector: "app-midnight-shift-calculation",
  templateUrl: "./midnight-shift-calculation.component.html",
  styleUrls: ["./midnight-shift-calculation.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class MidnightShiftCalculationComponent implements OnInit, OnDestroy {
  calculateMidnightShiftForm: FormGroup|LegacyAny;
  midNightShiftVal: number;
  unsubscribe = new Subject<void>();
  startConfigurationURL: string;
  constructor(
    
    private fb: FormBuilder,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private dynaDimmer: DynaDimmerStateService,
    private readonly httpClient: MultiOneHttpClient,
    private readonly cdr: ChangeDetectorRef
  ) {}
  ngOnInit() {
    // this.service.getEnvValue();
    // this.service.getEnvData
    //   .pipe(takeUntil(this.unsubscribe))
    //   .subscribe((url) => {
    //     if (url.length > 0) {
    //       this.unsubscribe.next(undefined);
    //       this.startConfigurationURL = url;
    //     }
    //   });
    const referUrl = environment.multiOneAPIUrl;
    this.startConfigurationURL = referUrl;
    this.calculateMidnightShiftForm = this.fb.group({
      daylightSaving: new FormControl(false),
      latitude: new FormGroup({
        degrees: new FormControl("", [Validators.required, Validators.min(0), Validators.max(89)]),
        hemisphere: new FormControl("", Validators.required),
        minutes: new FormControl("", [Validators.required, Validators.min(0), Validators.max(59)]),
        seconds: new FormControl("", [Validators.required, Validators.min(0), Validators.max(59)]),
      }),
      longitude: new FormGroup({
        degrees: new FormControl("", [Validators.required, Validators.min(0), Validators.max(179)]),
        hemisphere: new FormControl("", Validators.required),
        minutes: new FormControl("", [Validators.required, Validators.min(0), Validators.max(59)]),
        seconds: new FormControl("", [Validators.required, Validators.min(0), Validators.max(59)]),
      }),
      timeZone: new FormControl("", [
        Validators.required,
        Validators.min(-12),
        Validators.max(12),
        Validators.pattern(/^-?\d+$/)
      ]),
    });
    this.onChanges();
    this.calculateMidnightShiftForm.valueChanges
      .pipe(
        debounceTime(500),
        takeUntil(this.unsubscribe)
      )
      .subscribe(() => {
        if (this.calculateMidnightShiftForm.valid) {
          this.prepearePayloadAndSendToApi();
        }
      });
  }
  ngOnDestroy() {
    this.unsubscribe.next(undefined);
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 45 || charCode === 46 || charCode === 47 || charCode > 57));
  }
  inSingleDigitRange(): number[] {
    const restrictedSingleDigitVal = [];
    for (let i = 0; i < 10; i++) {
      restrictedSingleDigitVal.push("0" + i);
    }
    return restrictedSingleDigitVal;
  }
  onChanges(): void {
    // Auto-correction logic removed - validation errors now display without changing user input
    // Validators in form definition handle error detection
    
    this.calculateMidnightShiftForm
      .get("timeZone")
      .valueChanges.subscribe((val) => {
        if (val && val.length > 0) {
          const stringVal = val.toString();
          if (stringVal.length === 2 && stringVal[0] === '0' && stringVal !== '00') {
            this.calculateMidnightShiftForm
              .get("timeZone")
              .patchValue(parseInt(val, 10), { emitEvent: false });
          } else if (stringVal === '-0' || stringVal === '00') {
            this.calculateMidnightShiftForm
              .get("timeZone")
              .patchValue(0, { emitEvent: false });
          }
        }
      });
  }
  setMidNightShiftVal(event) {
    if (this.calculateMidnightShiftForm.valid) {
      this.dynaDimmer.dynaMidPointShiftValue.next(this.midNightShiftVal);

      this.activeModal.close();
    } else {
      this.markFormGroupTouched(this.calculateMidnightShiftForm);
    }
  }
  prepearePayloadAndSendToApi() {
    if (
      this.calculateMidnightShiftForm.valid &&
      this.calculateMidnightShiftForm.get("timeZone").value !== "-"
    ) {
      this.httpClient
        .getMidnightShiftCalculation(
          this.calculateMidnightShiftForm.value,
          this.startConfigurationURL
        )
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (result) => {
            if (result.hasOwnProperty("MidnightShift")) {
              // this.dynaDimmer.dynaMidPointShiftValue.next(result["MidnightShift"]);
              this.midNightShiftVal = result["MidnightShift"];
              this.cdr.markForCheck();
              // this.dynaDimmer.getDynaMidPointShiftValue.subscribe((response) => {
              //   this.midNightShiftVal = response;
              // });
            }
          },
          (err) => {
            const modalRef = this.modalService.open(ErrorComponent, {
              keyboard: false,
              centered: true,
              windowClass: "error-style, error-style1",
              backdrop: 'static'
            });
            modalRef.componentInstance.errorName = err["message"];
            modalRef.componentInstance.errorDescription = err["description"];
          }
          //window.alert(err["description"])
        );
    } else {
      this.markFormGroupTouched(this.calculateMidnightShiftForm);
    }
  }
  markFormGroupTouched(formGroup: FormGroup) {
    (<LegacyAny>Object).values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
  onCancel() {
    this.activeModal.close();
  }

  get isSetButtonDisabled(): boolean {
    return !this.calculateMidnightShiftForm.valid ||
           this.midNightShiftVal === undefined ||
           this.midNightShiftVal === null;
  }
}

